import { Component, OnInit } from '@angular/core';
import {
  AvlaGenericComponent,
  MessageService,
  I18nService,
  InfoMessageDTO,
} from 'shared-angular-components-avla';
import { AuthService, AvlaRestClientService } from 'base-angular-avla';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'help-component',
  template:
    '<button class="btn btn-default btn-circle" style="position:fixed; right: 5px; z-index: 3000; left:auto; top:55px;"' +
    '(click)="showSupportContactMessage()" ' +
    'target="_top" title="Ayuda y soporte">' +
    '<i class="fa fa-question"></i></button>',
  providers: [I18nService],
})
export class HelpComponent extends AvlaGenericComponent implements OnInit {
  constructor(
    protected restClientService: AvlaRestClientService,
    protected messageService: MessageService,
    protected router: Router,
    protected authService: AuthService,
    protected i18n: I18nService
  ) {
    super(restClientService, messageService, router, authService, i18n);
  }

  private helpShowed = false;

  private static get TIME_SECONDS_SHOW_HELP() {
    return 10;
  }

  ngOnInit() {
    setTimeout(() => {
      this.showSupportContactMessage();
    }, 250);
  }

  public showSupportContactMessage() {
    if (this.helpShowed) {
      return;
    }
    this.messageService.announcedMessage(
      new InfoMessageDTO(
        'info',
        '<h5>Ayuda y soporte</h5><br>' +
          'mail: <a href="mailto:garantiasfinancieras@avla.com?Subject=Ayuda%20desde%20aplicacion">' +
          'garantiasfinancieras@avla.com' +
          '</a><br>Anexo: <b>687</b>',
        HelpComponent.TIME_SECONDS_SHOW_HELP * 1000
      )
    );

    this.helpShowed = true;
    setTimeout(() => {
      this.helpShowed = false;
    }, HelpComponent.TIME_SECONDS_SHOW_HELP * 1000);
  }
}
